import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";

const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Huge book collection",
    detail:
      "Our library boasts an expansive and diverse book collection, a literary treasure trove waiting to be explored",
  },
  {
    icon: <MdCancel />,
    heading: "Online book reservation",
    detail:
      "Experience the convenience of online book reservation at our library, where you can reserve your favorite titles from the comfort of your home.",
  },
  {
    icon: <MdAnalytics />,
    heading: "One week extension",
    detail:
      "Extend your reading adventure by requesting a one-week extension for your borrowed books.",
  },
];
export default data;